import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ProjectRoutesCountMapState } from '@Pages/RetroSynthesis/RsBreadcrumbs/reducer';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { isPredictiveRetrosynthesisEnabled } from '@Pages/RetroSynthesis/predictiveUtils';

export function DrawTooltipContent() {
  return (
    <>
      <h4>Draw</h4>
      <span>Click to draw a target molecule for retrosynthesis</span>
    </>
  );
}

export function ProjectListTooltipContent() {
  return (
    <>
      <h4>My Retrosynthesis Projects </h4>
      <span>Click to view a list of your retrosynthesis projects</span>
    </>
  );
}

function ProjectTitle({ projectInfo }) {
  const { projectName } = projectInfo || {};
  const title = projectName ? `Project: ${projectName}` : '';
  return !isEmpty(title) ? <InnerHTML tag="h4" html={title} /> : null;
}

ProjectTitle.propTypes = {
  projectInfo: PropTypes.object,
};

export function ProjectTooltipContent({ routesInfo }) {
  switch (routesInfo) {
    case ProjectRoutesCountMapState.LOADING:
      return '...';
    case ProjectRoutesCountMapState.ERROR:
      return `with unknown routes count`;
    default: {
      const { predictedRoutesCount, publishedRoutesCount, customizedRoutesCount } = routesInfo || {};
      return (
        <>
          <ProjectTitle projectInfo={routesInfo} />
          <div className="routes-count-block">
            {!isNil(customizedRoutesCount) && (
              <div className="routes-count-row">
                <div className="routes-count customized">{customizedRoutesCount}</div>
                <span>{`Customized route${customizedRoutesCount > 1 ? 's' : ''}`}</span>
              </div>
            )}
            {!isNil(publishedRoutesCount) && (
              <div className="routes-count-row">
                <div className="routes-count published">{publishedRoutesCount}</div>
                <span>{`Published route${publishedRoutesCount > 1 ? 's' : ''}`}</span>
              </div>
            )}
            {isPredictiveRetrosynthesisEnabled() && !isNil(predictedRoutesCount) && (
              <div className="routes-count-row">
                <div className="routes-count predicted">{predictedRoutesCount}</div>
                <span>{`Predicted route${predictedRoutesCount > 1 ? 's' : ''}`}</span>
              </div>
            )}
          </div>
        </>
      );
    }
  }
}

ProjectTooltipContent.propTypes = {
  routesInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export function ProjectRouteTooltipContent({ routeLabel, projectInfo }) {
  return (
    <>
      <h4>{routeLabel}</h4>
      {projectInfo && <div>{projectInfo.projectName}</div>}
    </>
  );
}

ProjectRouteTooltipContent.propTypes = {
  routeLabel: PropTypes.string,
  projectInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
